import React from 'react'

let themeValue = ''
if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
  themeValue = 'dark'
} else {
  themeValue = 'light'
}
// console.log(themeValue);

export const initialThemeState = {
  theme: themeValue,
  setTheme: () => null,
}

const ThemeContext = React.createContext(initialThemeState)
export default ThemeContext
